import type { Guild, GuildMember } from './api';

export interface ProjectAuthority {
  ready: boolean;
  isOwner: boolean;
  isAdmin: boolean;
  canManageProject: boolean;
  canGovernAdmins: boolean;
}

const unavailableAuthority: ProjectAuthority = {
  ready: false,
  isOwner: false,
  isAdmin: false,
  canManageProject: false,
  canGovernAdmins: false,
};

export function deriveProjectAuthority(
  accountId: string | null,
  guild: Guild | undefined,
  viewer: GuildMember | undefined,
  snapshotsAuthoritative: boolean,
  requireRoster: boolean,
): ProjectAuthority {
  if (
    !snapshotsAuthoritative ||
    !accountId ||
    !guild ||
    (requireRoster &&
      (!viewer ||
        viewer.guild_id !== guild.id ||
        viewer.user_id !== accountId ||
        viewer.role !== 'member' ||
        viewer.membership_role !== guild.membership_role))
  ) {
    return unavailableAuthority;
  }

  const isOwner = guild.owner_id === accountId && guild.membership_role === 'member';
  if (guild.owner_id === accountId && !isOwner) return unavailableAuthority;

  const isAdmin = !isOwner && guild.membership_role === 'admin';
  if (isAdmin && requireRoster && viewer?.owner_id != null) return unavailableAuthority;
  return {
    ready: true,
    isOwner,
    isAdmin,
    canManageProject: isOwner || isAdmin,
    canGovernAdmins: isOwner,
  };
}
